// extracted by mini-css-extract-plugin
module.exports = {"left":"style_left__2yov7","right":"style_right__3CXkk","shadowRight":"style_shadowRight__143rv"};